//@flow
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import PedidoEmMapaCrudList from './PedidoEmMapaCrudList';
import PedidoEmMapaEdit from './PedidoEmMapaEdit';
export default class PedidoEmMapaCrud extends React.PureComponent<{}> {
  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route path="/pedidoEmMapa" exact component={PedidoEmMapaCrudList} />
          <Route path="/pedidoEmMapa/novo" exact component={PedidoEmMapaEdit} />
          <Route path="/pedidoEmMapa/:id" component={PedidoEmMapaEdit} />
        </Switch>
      </React.Fragment>
    );
  }
}
